var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModule1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.59995V8.19995H9.4V9.59995H8Z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.6V12.2H15.4V13.6H8Z",
    fill: "#192048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.6V16.2H15.4V17.6H8Z",
    fill: "#192048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.89995C4 2.96264 4.76269 2.19995 5.7 2.19995H12.6683L12.6703 2.20048C12.6844 2.20413 12.7061 2.20924 12.7325 2.21176L12.7424 2.21237C12.8041 2.21621 12.8651 2.22821 12.9237 2.24807L12.9749 2.26476L12.9225 2.24766C12.9342 2.25168 12.9451 2.25517 12.9537 2.25786L12.9749 2.26476L12.9871 2.26889L12.9938 2.2718C13.0689 2.30469 13.1377 2.35053 13.197 2.40723L19.1927 8.40294C19.249 8.46175 19.2945 8.52992 19.3274 8.60438C19.3351 8.62296 19.3418 8.64253 19.3477 8.66303L19.3519 8.67525C19.3717 8.73384 19.3836 8.79481 19.3875 8.85656L19.3882 8.86511C19.3906 8.89119 19.3953 8.91275 19.399 8.92735L19.4 8.93129V19.9C19.4 20.8373 18.6373 21.6 17.7 21.6H5.7C4.76269 21.6 4 20.8373 4 19.9V3.89995ZM12 3.59995H5.4V20.1999H18.0021L17.9999 9.59995H12.7C12.5143 9.59995 12.3363 9.5262 12.205 9.39493C12.0737 9.26365 12 9.0856 12 8.89995V3.59995ZM17.0103 8.19995L13.4 4.58969V8.19995H17.0103Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule1);
export default __webpack_public_path__ + "static/media/CustomModule1.15861f3d6eda9f8e618534092795dc1a.svg";
export { ForwardRef as ReactComponent };